// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoPlayer_videoContainer__AGQP3","video":"VideoPlayer_video__hYzn0","playButtonBackdrop":"VideoPlayer_playButtonBackdrop__4dEqC"};